import { render, staticRenderFns } from "./NewBusiness.vue?vue&type=template&id=09aec91b&scoped=true&"
import script from "./NewBusiness.vue?vue&type=script&lang=js&"
export * from "./NewBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09aec91b",
  null
  
)

export default component.exports